export default class kitchenitemsEffectManager {
    constructor(){

    }
    mainLeft($target,type){

        if(type==="set"){

            TweenMax.set($target,{
                opacity:0, x:'-40px', y:'-20px', rotation: 2, transformOrigin:"left 50%"
            });

        }else{

            TweenMax.to($target, .88,
                {
                    opacity:1,
                    x:'0px',
                    y:'0px',
                    rotation: 0,
                    ease: Power3.easeOut
                }
            );

        }

    }

    mainRight($target,type){

        if(type==="set"){

            TweenMax.set($target,{
                opacity:0, x:'40px', y:'-20px', rotation: -2, transformOrigin:"right top"
            });

        }else{

            TweenMax.to($target, .88,
                {
                    opacity:1,
                    x:'0px',
                    y:'0px',
                    rotation: 0,
                    ease: Power3.easeOut
                }
            );

        }

    }

    y($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                opacity:0, y:'40px'
            });
        }else{
            TweenMax.staggerTo($target,.88, {
                y:'0px',
                opacity:1,
                ease: Power3.easeOut
            },0.2);
        }

    }

    line($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                width:'0%'
            });
        }else{

            let _w = ( window.innerWidth>750 )?"65.5%":"58%";

            TweenMax.to([$target[1],$target[2]],1.88, {
                width:_w,
                ease: Power3.easeOut,
                onComplete:() => {
                    TweenMax.to($target[0],1.88, {
                        width:_w,
                        ease: Power3.easeOut,
                        onComplete:() => {
                            $target[0].classList.add("is-done");
                        }
                    });
                }
            });
        }

    }


}
